import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// views
import Login from "views/auth/Login.js";
import ForgotPassword from "views/auth/forgotPassword.js";


export default function Auth() {
  return (
    <>
      {/* <Navbar transparent /> */}
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-blueGray-800 bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("assets/img/register_bg_2.png").default + ")",
            }}
          ></div>
          <Routes>
            <Route path="login" element={<Login />} />
            <Route path="forgotPassword" element={<ForgotPassword />} />
            <Route path="*" element={<Navigate to="login" replace />} />
          </Routes>

        </section>
      </main>
    </>
  );
}

